// extracted by mini-css-extract-plugin
export default {"button":"redemption-confirmation_button__NkJSi","close-button":"redemption-confirmation_close-button__BuGGc"};